// extracted by mini-css-extract-plugin
module.exports = {"container":"NotConnected_container__1hMHI","title":"NotConnected_title__1o5CO","glitch":"NotConnected_glitch__n1ug2"};